import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import usePrefersReducedMotion from "./usePrefersReducedMotion";

const ease = [0.22, 1, 0.36, 1];

/**
 * Route enter animation.
 *
 * Important: App.js mounts a fresh Layout per <Route>, so AnimatePresence
 * exit/wait never runs across navigations and caused blank flashes.
 * Enter-only opacity/y (no CSS filter blur) is stable and animates every route.
 */
export default function PageTransition({ children, fillHeight = false }) {
  const location = useLocation();
  const reduced = usePrefersReducedMotion();

  const shellClass = fillHeight
    ? "flex h-full min-h-0 w-full flex-1 flex-col"
    : "w-full";

  if (reduced) {
    return <div className={shellClass}>{children}</div>;
  }

  return (
    <motion.div
      key={location.pathname}
      className={shellClass}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.26, ease }}
    >
      {children}
    </motion.div>
  );
}
